import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { RecuperarSenhaPageProvider } from './recuperar-senha.provider';

/**
 * Generated class for the RecuperarSenhaPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-recuperar-senha',
  templateUrl: 'recuperar-senha.html',
})
export class RecuperarSenhaPage {

  senha: string;

  constructor(public navCtrl: NavController, public navParams: NavParams, public recuperarSenhaProvider: RecuperarSenhaPageProvider) {
  }

  recuperar() {
    this.recuperarSenhaProvider.recuperarSenha(this.senha).subscribe(data => {

    }, error => {

    })
  }

}



// WEBPACK FOOTER //
// ./src/pages/recuperar-senha/recuperar-senha.ts